<template>
  <div class="ioRecord">
    <!-- <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div class="right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <!-- <template>
            <template v-if="showList"> -->
          <!-- <div class="form-group">
            <label>集团:</label>
            <el-select filterable v-model="search.groupId" placeholder="请选择">
              <el-option
                v-for="item in groupList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div> -->
          <div class="form-group">
            <label for="bdate">开始时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd"
              v-model="search.beginTime"
              type="date"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for="bdate">结束时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd"
              v-model="search.endTime"
              type="date"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="download_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
              >
                导出
              </button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <div v-show="showList" class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
          <el-table-column
              show-overflow-tooltip
              label="岗位名称"
              prop="areaName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="统计时间"
              prop="statisticalDate"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="今日总欠费"
              prop="todayMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="昨日总欠费"
              prop="yesterdayMoney"
            ></el-table-column>
            <!-- <el-table-column
              show-overflow-tooltip
              label="当日欠费"
              prop="arrearsMoney"
            ></el-table-column> -->
            <el-table-column
              show-overflow-tooltip
              label="追缴当日欠费"
              prop="todayOwingMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="追缴历史欠费"
              prop="historyOwingMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="当日新增欠费"
              prop="newMoney"
            ></el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getArrearsRateReportByPost } from "@/api/url";
import AreaTree from "../../commons/areaTree";
import Page from "../../commons/page";
import dayjs from "dayjs";
export default {
  data() {
    return {
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      groupList: [],
      tableListData: [],
      tableListDataTitle: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        beginTime: dayjs()
          .subtract(1, "month")
          .format("YYYY-MM-DD"),
        endTime: dayjs().format("YYYY-MM-DD"),
       
      },
      value4: "",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      this.$get(getArrearsRateReportByPost(), {
        page: curPage,
        limit: this.search.pageSize,

        beginTime: this.search.beginTime,
        endTime: this.search.endTime,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },

    searchList: function() {
      var flTime = this.timeCompare(this.search.beginTime, this.search.endTime);
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (!Boolean(this.search.beginTime)) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (!Boolean(this.search.endTime)) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }

      var compareTime = this.timeCompare(
        this.search.endTime,
        dayjs(this.search.beginTime)
          .add(1, "month")
          .format("YYYY-MM-DD")
      );

      if (compareTime) {
        return this.$layer.msg("请选择一个月以内的日期", { time: 1 });
      }

      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function(bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },

    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    // getGroupList() {
    //   return this.$get(fetchPropertyList()).then((res) => {
    //     const { status, data } = res;
    //     if (status === 200) {
    //       this.groupList = data;
    //     }
    //   });
    // },
    // async initGroup() {
    //   await this.getGroupList();
    //   this.search.groupId = this.groupList[0].id;
    //   this.tableList(this.search.pageNumber);
    // },
    downloadData() {
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/ratePostRiseExport",
        {
        
          beginTime: this.search.beginTime,
          endTime: this.search.endTime,
        },
        "岗位欠费率报表"
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  components: {
    Page,
    AreaTree,
  },

  mounted: function() {
    this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
  width: 16px;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
}
.show-list {
  height: 500px;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.download_btn {
  display: inline-block;
  margin-left: 15px;
}
</style>
